import ContactPage from './ContactPage'
export { ContactPage }
export default ContactPage
